"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_2ggbdc4940 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/helpers.js";
  var hash = "29e7e74da6fc619f955f952cb94792902ed201a9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 18
        },
        end: {
          line: 9,
          column: 3
        }
      },
      "2": {
        start: {
          line: 10,
          column: 19
        },
        end: {
          line: 10,
          column: 52
        }
      },
      "3": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 25
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 14
        }
      },
      "5": {
        start: {
          line: 15,
          column: 29
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "6": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 30
        }
      },
      "7": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 30
        }
      },
      "8": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 45
        }
      },
      "9": {
        start: {
          line: 18,
          column: 12
        },
        end: {
          line: 18,
          column: 57
        }
      },
      "10": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 70
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 25
          },
          end: {
            line: 3,
            column: 26
          }
        },
        loc: {
          start: {
            line: 3,
            column: 50
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 15,
            column: 30
          }
        },
        loc: {
          start: {
            line: 15,
            column: 41
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 30
          },
          end: {
            line: 15,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 35
          },
          end: {
            line: 15,
            column: 36
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 30
          }
        }, {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 30
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "29e7e74da6fc619f955f952cb94792902ed201a9"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanFileSize = exports.fetchTree = void 0;

var _core = require("../../core");

cov_2ggbdc4940.s[0]++;

var fetchTree = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var url, config, _config, response, _ref3, tree;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, config = _ref.config;
            cov_2ggbdc4940.f[0]++;
            _config = (cov_2ggbdc4940.s[1]++, _objectSpread({
              cache: {
                maxAge: 1 * 2 * 1000 // 2 sec cache override

              }
            }, config));
            cov_2ggbdc4940.s[2]++;
            _context.next = 6;
            return (0, _core.get)({
              url: url,
              config: _config
            });

          case 6:
            response = _context.sent;
            _ref3 = (cov_2ggbdc4940.s[3]++, response), tree = _ref3.tree;
            cov_2ggbdc4940.s[4]++;
            return _context.abrupt("return", tree);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchTree(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchTree = fetchTree;
cov_2ggbdc4940.s[5]++;

var humanFileSize = function humanFileSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2ggbdc4940.b[0][0]++, 0);
  cov_2ggbdc4940.f[1]++;
  cov_2ggbdc4940.s[6]++;

  if (size === 0) {
    cov_2ggbdc4940.b[1][0]++;
    cov_2ggbdc4940.s[7]++;
    return '0 B';
  } else {
    cov_2ggbdc4940.b[1][1]++;
  }

  var units = (cov_2ggbdc4940.s[8]++, ['B', 'KB', 'MB', 'GB', 'TB']);
  var i = (cov_2ggbdc4940.s[9]++, Math.floor(Math.log(size) / Math.log(1024)));
  cov_2ggbdc4940.s[10]++;
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + units[i];
};

exports.humanFileSize = humanFileSize;